module.exports = __webpack_public_path__ + "static/media/trapezoid.e9b4d759.png";